import { useState } from "react";
import uniqid from "uniqid";

import Cell from "./Cell";
import NoteCell from "./NoteCell";

// cellAlign is an array containing L, C, R
// so is noteAlign
const Row = ({
  cellTexts,
  noteTexts,
  showPopUp,
  className = "",
  cellAlign,
}) => {
  const [hovering, setHovering] = useState(false);

  const getAlignCss = (index, defaultChar = "L") => {
    const charToCss = {
      L: "text-left",
      C: "text-center",
      R: "text-right",
    };

    // out of range
    if (!cellAlign || index >= cellAlign.length || index < 0) {
      return charToCss[defaultChar];
    } else {
      const align = cellAlign[index];
      return charToCss[align];
    }
  };

  const cellNum = cellTexts.length;

  return (
    <>
      {cellTexts.map((text, index) => (
        <Cell
          onClick={showPopUp}
          key={uniqid()}
          text={text}
          className={`${hovering ? "brightness-90" : ""} ${getAlignCss(index, "C")} ${className}`}
          setHovering={setHovering}
        />
      ))}
      {noteTexts.map((text, index) => (
        <NoteCell
          onClick={showPopUp}
          key={uniqid()}
          className={`${hovering ? "brightness-90" : ""} ${getAlignCss(cellNum + index, "L")} ${className}`}
          setHovering={setHovering}
          text={text}
        />
      ))}
    </>
  );
};

export default Row;
